import usePicklist from "@/hooks/usePicklist";
import PicklistContent from "@/modules/PicklistContent";
import api from "@/utils/api";
import { QUERY_KEYS } from "@/utils/const";
import { useQuery } from "@tanstack/react-query";
import {
  useCallback,
  useEffect,
  useMemo,
  useRef
} from "react";
import { useLocation } from "react-router-dom";
import ReactToPrint from "react-to-print";

const OutgoingViewPage = () => {
    useEffect(() => {
        document.documentElement.classList.toggle("dark", false);
        document.documentElement.classList.toggle("core-ui-dark", false);
    },[]);

  // const { apikey,id } = useParams();
  const { search } = useLocation();
  const query = new URLSearchParams(search);

  const apikey = query.get("apikey");
  const id = query.get("id");
  // const [showModal, setShowModal] = useState(false);
  const contentToPrintRef = useRef<HTMLDivElement>(null);
  const printBtnRef = useRef<HTMLButtonElement>(null);
  const { transactionGroupId, show, hideModal } = usePicklist((state) => ({
    transactionGroupId: state.transactionGroupId,
    show: state.show,
    hideModal: state.hidePicklistModal,
  }));

  //   Get picklist details

  const { data: responseData } = useQuery(
    [QUERY_KEYS.PICKLIST, id],
    () => api.getPicklist(id ?? "",{
      headers: { "X-Api-Key": apikey },
    }),
    {
      enabled: id !== undefined && id !== null,
    }
  );

  const data = useMemo(() => {
    if (
      !responseData ||
      responseData.success === false ||
      !responseData.payload
    )
      return undefined;

    return responseData.payload.data;
  }, [responseData]);

  const handlePrint = useCallback(() => {
    if (printBtnRef && printBtnRef.current) {
      printBtnRef.current.click();
    }
  }, []);

  const handleModalChange = (state: boolean) => {
    if (!state) hideModal();
  };

  return (
    <div className="">
              <div className="flex flex-col items-center justify-center rounded-lg py-10 bg-gray-200 shadow dark:border-gray-700  dark:bg-gray-900">
                <div className=" w-[215.9mm] flex justify-end pb-4 pe-4">
                  {/* <ButtonSolid label="Print" onClick={handlePrint} /> */}
                </div>
                <div className="overflow:overflow-y-scroll relative h-auto w-auto overflow-auto bg-gray-200 scrollbar-thin scrollbar-track-gray-100 scrollbar-thumb-primary-600 dark:bg-gray-700 dark:scrollbar-track-gray-600">
                  <div>
                    <ReactToPrint
                      trigger={() => {
                        return (
                          <button type="button" ref={printBtnRef} className="hidden">
                            Print
                          </button>
                        );
                      }}
                      content={() => contentToPrintRef.current}
                    />
                    <PicklistContent ref={contentToPrintRef} data={data} />
                  </div>
                </div>
              </div>
            </div>
  );
};

const OutgoingPicklistWrapper = () => {
  return (
    <>
      <OutgoingViewPage />
    </>
  );
};

export default OutgoingPicklistWrapper;
